import { Container, Reveal, RevealGroup } from '@/components/common'
import { stories } from '@/constants/stories'

export const StoriesOfChange = () => {
  return (
    <section className="bg-ibon-dark py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
              Real experiences. <span className="text-white/40">Real outcomes.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-white/70">
              Behind every programme are individuals whose experiences show the value of
              opportunity, mentorship, collaboration, and support.
            </p>
          </Reveal>
        </div>

        <RevealGroup
          className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 lg:grid-cols-3"
          step={120}
        >
          {stories.map(({ title, quote, author }) => (
            <figure key={title} className="flex flex-col bg-ibon-dark p-8 lg:p-10">
              <span className="text-5xl font-bold leading-none text-ibon-sky">&ldquo;</span>
              <h3 className="mt-6 text-xl font-bold tracking-tight text-white">{title}</h3>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-white/70">
                {quote}
              </blockquote>
              <figcaption className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-white/70">
                {author}
              </figcaption>
            </figure>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
